
import { call, put, takeEvery } from "redux-saga/effects";
import { phongThiApi } from "../../../api/tct/phongThiApi";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import { IPhongThi } from "../../../model/respone/tct/IPhongThi";
import { ePhongThiActionIds, IPhongThiActionTypeBase, IPhongThiActionTypes } from "../../action-types/tct/IPhongThiActions";
import { rootActions } from "../../actions/rootActions";
import { IIdsRequest } from "../../../model/request/IIdsRequest";
import { IPhongThiChiaThuCongRequest } from "../../../model/request/tct/IPhongThiChiaThuCongRequest";
import { IDuKienMoPhong } from "../../../model/respone/tct/IDuKienMoPhong";
import { IChiaPhongTheoSoPhongRequest } from "../../../model/request/tct/IChiaPhongTheoSoPhongRequest";
import { IChiaSinhVienVaoPhongRequest } from "../../../model/request/tct/IChiaSinhVienVaoPhongRequest";
const mainAction = rootActions.toChucThi.phongThi;
export function* phongThiSaga(): any {
    yield takeEvery(ePhongThiActionIds.LOAD_START, loadWorker)
    yield takeEvery(ePhongThiActionIds.SAVE_START, saveWorker)
    yield takeEvery(ePhongThiActionIds.UPDATES_START, updateWorker)
    yield takeEvery(ePhongThiActionIds.DELETE_START, deleteWorker)
    yield takeEvery(ePhongThiActionIds.CHIA_THUC_CONG_START, chiaThuCongWorker)
    yield takeEvery(ePhongThiActionIds.DU_KIEN_MO_PHONG_START, duKienMoPhongWorker)
    yield takeEvery(ePhongThiActionIds.UPDATE_DU_KIEN_MO_PHONG_START, updateDuKienMoPhongWorker)
    yield takeEvery(ePhongThiActionIds.CHIA_PHONG_THEO_SO_LUONG_PHONG_START, chiaPhongTheoSoLuongPhongWorker)
    yield takeEvery(ePhongThiActionIds.CHIA_SINH_VIEN_VAO_PHONG_START, chiaSinhVienVaoPhongWorker)
}

function* loadWorker(action: IPhongThiActionTypes): any {
    const payload = action.payload as IPhongThiActionTypeBase<undefined>
    const dotThiId = payload.dotThiId;
    const res: IBaseRespone = yield call(phongThiApi.SelectByDot, dotThiId)
    if (res.is_success) {
        yield put(mainAction.LOAD_SUCCESS({
            data: res.data,
            dotThiId
        }))
    } else {
        yield put(mainAction.LOAD_ERROR({
            data: res.message ?? "Có lỗi",
            dotThiId
        }))
    }
}
function* updateWorker(action: IPhongThiActionTypes): any {
    debugger;
    const payload = action.payload as IPhongThiActionTypeBase<IPhongThi[]>
    const dotThiId = payload.dotThiId;
    const res: IBaseRespone = yield call(phongThiApi.Updates, payload.data)
    if (res.is_success) {
        yield put(mainAction.UPDATES_SUCCESS({
            data: res.data,
            dotThiId
        }))
    } else {
        yield put(mainAction.UPDATES_ERROR({
            data: res.message ?? "Có lỗi",
            dotThiId
        }))
    }
}

function* saveWorker(action: IPhongThiActionTypes): any {
    const payload = action.payload as IPhongThiActionTypeBase<IPhongThi>
    const dotThiId = payload.dotThiId;
    const monThi = payload.data as IPhongThi
    let res: IBaseRespone;
    if (monThi.id_dot_thi_phong > 0) {
        res = yield call(phongThiApi.Update, monThi)
    } else {
        res = yield call(phongThiApi.Insert, monThi)
    }
    if (res.is_success) {
        yield put(mainAction.SAVE_SUCCESS({
            data: res.data,
            dotThiId
        }))
    } else {
        yield put(mainAction.SAVE_ERROR({
            data: res.message ?? "Có lỗi",
            dotThiId
        }))
    }
}

function* deleteWorker(action: IPhongThiActionTypes): any {
    const payload = action.payload as IPhongThiActionTypeBase<IIdsRequest>
    const dotThiId = payload.dotThiId;
    const request = payload.data
    const res: IBaseRespone = yield call(phongThiApi.Deletes, request)
    if (res.is_success) {
        yield put(mainAction.DELETE_SUCCESS({
            data: request,
            dotThiId
        }))
    } else {
        yield put(mainAction.DELETE_ERROR({
            data: res.message ?? "Có lỗi",
            dotThiId
        }))
    }
}

function* chiaThuCongWorker(action: IPhongThiActionTypes): any {
    const payload = action.payload as IPhongThiActionTypeBase<IPhongThiChiaThuCongRequest>
    const dotThiId = payload.dotThiId;
    const request = payload.data
    const res: IBaseRespone = yield call(phongThiApi.ChiaThuCong, request)
    if (res.is_success) {
        yield put(mainAction.CHIA_THUC_CONG_SUCCESS({
            data: res.data,
            dotThiId
        }))
    } else {
        yield put(mainAction.CHIA_THUC_CONG_ERROR({
            data: res.message ?? "Có lỗi",
            dotThiId
        }))
    }
}

function* duKienMoPhongWorker(action: IPhongThiActionTypes): any {
    const payload = action.payload as IPhongThiActionTypeBase<undefined>
    const dotThiId = payload.dotThiId;
    const res: IBaseRespone = yield call(phongThiApi.DuKienMoPhong, dotThiId)
    if (res.is_success) {
        yield put(mainAction.DU_KIEN_MO_PHONG_SUCCESS({
            data: res.data,
            dotThiId
        }))
    }
    else {
        yield put(mainAction.DU_KIEN_MO_PHONG_ERROR({
            data: res.message ?? "Có lỗi",
            dotThiId
        }))
    }
}

function* updateDuKienMoPhongWorker(action: IPhongThiActionTypes): any {
    const payload = action.payload as IPhongThiActionTypeBase<IDuKienMoPhong[]>
    const dotThiId = payload.dotThiId;
    const request = payload.data
    const res: IBaseRespone = yield call(phongThiApi.UpdateDuKienMoPhong, request)
    if (res.is_success) {
        yield put(mainAction.UPDATE_DU_KIEN_MO_PHONG_SUCCESS({
            data: res.data,
            dotThiId
        }))
    } else {
        yield put(mainAction.UPDATE_DU_KIEN_MO_PHONG_ERROR({
            data: res.message ?? "Có lỗi",
            dotThiId
        }))
    }
}

function* chiaPhongTheoSoLuongPhongWorker(action: IPhongThiActionTypes): any {
    const payload = action.payload as IPhongThiActionTypeBase<IChiaPhongTheoSoPhongRequest>
    const dotThiId = payload.dotThiId;
    const request = payload.data
    const res: IBaseRespone = yield call(phongThiApi.ChiaPhongTheoSoLuongPhong, request)
    if (res.is_success) {
        yield put(mainAction.CHIA_PHONG_THEO_SO_LUONG_PHONG_SUCCESS({
            data: res.data,
            dotThiId
        }))
    } else {
        yield put(mainAction.CHIA_PHONG_THEO_SO_LUONG_PHONG_ERROR({
            data: res.message ?? "Có lỗi",
            dotThiId
        }))
    }
}

function* chiaSinhVienVaoPhongWorker(action: IPhongThiActionTypes): any {
    const payload = action.payload as IPhongThiActionTypeBase<IChiaSinhVienVaoPhongRequest>
    const dotThiId = payload.dotThiId;
    const request = payload.data
    const res: IBaseRespone = yield call(phongThiApi.ChiaSinhVienVaoPhong, request)
    if (res.is_success) {
        yield put(mainAction.CHIA_SINH_VIEN_VAO_PHONG_SUCCESS({
            data: res.data,
            dotThiId
        }))
    } else {
        yield put(mainAction.CHIA_SINH_VIEN_VAO_PHONG_ERROR({
            data: res.message ?? "Có lỗi",
            dotThiId
        }))
    }
}